import React, { Fragment, useState, useContext } from "react";
import { HashLink as Link } from "react-router-hash-link";

import { Grid } from "@mui/material";

import CustomerFormModal, {
  getCreateCustomerOpenButton,
} from "./CustomerFormModal";
import { string2FormattedString } from "../../../shared/utils/utils";
import LoadingPage from "../../../react_utils/LoadingPage";
import CharsInput from "../../../react_utils/fields/CharsInput";
import Table from "../../../react_utils/table/Table";
import TablePagination from "../../../react_utils/table/TablePagination";
import Icon from "../../../react_utils/Icon";
import useUsers from "../../../shared/hooks/users/useUsers";
import { adminEndpoints } from "../../../shared/api/endpoints";
import { AuthContext } from "../../../shared/contexts/AuthContext";

export default function Customers() {
  const [chosenCustomer, setChosenCustomer] = useState(null);

  const { apiClient } = useContext(AuthContext);

  const {
    users: customers,
    search,
    pagination,
    data,
  } = useUsers(apiClient, adminEndpoints.customer);

  return (
    <Fragment>
      {!customers ? <LoadingPage /> : null}
      <Grid container justify="center">
        <Grid xs={12} sm={12} md={6} item>
          <CustomerFormModal
            modalProps={{ getOpenButton: getCreateCustomerOpenButton }}
            resetParent={data.update}
          />
          <CustomerFormModal
            customer={chosenCustomer}
            modalProps={{
              isOpen: !!chosenCustomer,
              setIsOpen: (isOpen) => {
                if (!isOpen) setChosenCustomer(null);
              },
            }}
            resetParent={data.update}
          />
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={6}
          item
          display="flex"
          justifyContent="flex-end"
        >
          <CharsInput label="Suche" onChange={(v) => search.setInput(v)} />
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          {customers ? (
            <Table
              columns={[
                { name: "Nachname", key: "last_name" },
                { name: "Vorname", key: "first_name" },
                { name: "Nutzer", key: "username" },
                { name: "Standort", key: "location" },
                { name: "", key: "location_link", getLink: () => null },
                { name: "E-Mail", key: "email" },
              ]}
              rows={customers.map((customer) => ({
                // key: `${customer.id}`,
                first_name: customer.first_name,
                last_name: customer.last_name,
                username: customer.username,
                email: customer.email,
                date_joined: string2FormattedString(customer.date_joined),
                link: (row) => {
                  setChosenCustomer(customer);
                },
                // address: customer._location?.address || ''
                location_link: customer.location && (
                  <Link
                    to={`/standort/${customer.location}`}
                    style={{ textDecoration: "none", width: "100%" }}
                  >
                    <Icon
                      icon={"location"}
                      sx={{ color: "secondary.main" }}
                      fontSize="small"
                    />
                  </Link>
                ),
                location:
                  customer._location?.name || customer._location?.address || "",
              }))}
            />
          ) : null}
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          display="flex"
          justifyContent="center"
          paddingTop={"10px"}
        >
          <TablePagination
            nPages={pagination.nPages}
            page={pagination.page}
            setPage={pagination.setPage}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

Customers.propTypes = {};
